import React from 'react';
import ReactDOM from 'react-dom';

// Styles & Assets
import styles from './Modal.module.css';

// Components
import Backdrop from '../Backdrop/Backdrop';

// Interfaces
import { ReactNode } from 'react';

// Modal: component that creats a modal. It can be closed by clicking outside. 
// Renders the backdrop creating a portal so it is rendered in the backdrop-root
// element. It receives as a parameter:
//  -show: boolean that indicates if the backdrop has to be visible.
//  -clicked: function that closes the backdrop if we pass true as a parameter.
//  -children: children parameter that renders all the specific elements inside the Modal.
// -permanent: if set to true keeps the modal element displayed (even if its hidden). Useful if we
// don't want the component inside the modal to unmount. 
const Modal: React.FC<{
    show: boolean,
    setShowModal: (closed: boolean) => void,
    classesModal?: string,
    classesBackdrop?: string,
    secondModal?: boolean,
    permanent?: boolean,
    children: ReactNode,
}>
    = ({ show, setShowModal, classesModal, classesBackdrop, secondModal, permanent, children }) => {

        const handleInsideClick = (e: React.FormEvent) => {
            //avoid closing modal when its content is clicked
            e.stopPropagation();
        };

        const handleClose = (evt: React.MouseEvent<HTMLElement>) => {
            //close modal when outside is clicked
            setShowModal(false);
            evt.stopPropagation();
        };

        return (
            <>
                {(show || permanent) && ReactDOM.createPortal(
                    <div onClick={handleClose} data-testid = 'modal-wrapper'>
                        {ReactDOM.createPortal(
                            <Backdrop
                                show={show}
                                clicked={setShowModal}
                                classesBackdrop={classesBackdrop}
                                secondModal={secondModal}
                            />,
                            document.getElementById(`backdrop${secondModal ? '2' : ''}-root`) as HTMLElement,
                        )}
                        <div
                            className={classesModal || styles.Modal}
                            style={{
                                display: show ? 'flex' : 'none',
                                zIndex: secondModal ? 1100 : 1000
                            }}
                            onClick={handleInsideClick}
                        >
                            {children}
                        </div>
                    </div>
                    , document.getElementById(`modal${secondModal ? '2' : ''}-root`) as HTMLElement,
                )}
            </>
        );
    };

export default Modal;